let theme = {
  textFieldColor: "#b5bcbc29",
};

export default theme;
